<template>
  <!-- <header id="masthead"> -->
  <nav
    class="navbar navbar-expand-lg navbar-light nav-bg-color"
    style="z-index:1; position: fixed; width: 100%;top: 0px"
  >
    <div>
      <b-modal
        ref="my-modal"
        id="modal-center"
        centered
        title="Where do you want the delivery?"
        hide-footer
      >
        <!-- <div class="card">
                <div class="d-flex justify-content-between" role="button">
                    <div class="p-3">
                        <i class="fa fa-map-marker" style="font-size: 24px"></i>
                    </div>
                    <div class="p-3">
                        Deliver in <strong>Noida</strong>
                    </div>
                    <div class="p-3">
                        <i class="fa fa-arrow-right"></i>
                    </div>
                </div>
            </div> -->
        <!-- <div class="card pt-2">
                <div>
                    <p class="text-center pt-2">
                        <strong>Or Select your city</strong>
                    </p>
                    <p class="text-center">
                        <strong>Top Searched Cities</strong>
                    </p>
                </div>
                <div class="d-flex justify-content-between p-3">
                    <div v-for="(city, i) in cities" :key="i" @click="chnageLocation(city.name)">
                        <span role="button">
                            <i :class="`fa ${city.icon}`"></i>&nbsp;&nbsp;
                            {{ city.name }}
                        </span>
                    </div>
                </div>
            </div> -->
        <div class="card-custom p-3" role="button" @click="getCurrentLocation">
          <div class="pl-3 pr-3">
            <p class="text-danger text-center">{{ errorMsg }}</p>
          </div>
          <div class="d-flex justify-content-around">
            <div>
              Locate Yourself
            </div>
            <div>
              <i class="fa fa-location-arrow"></i>
            </div>
            <div v-show="loading">
              <b-spinner variant="primary" label="Spinning"></b-spinner>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center p-2">
          <!-- <span class="border border-bottom-dark border-bottom-0" style="min-width: 100px, height: 2px"></span> -->
          <div>
            <i class="fa fa-minus" aria-hidden="true"></i>
            <i class="fa fa-minus" aria-hidden="true"></i>
            <i class="fa fa-minus" aria-hidden="true"></i>
            <i class="fa fa-minus" aria-hidden="true"></i>
            <i class="fa fa-minus" aria-hidden="true"></i>
          </div>
          <div>
            <i class="fa fa-caret-left" aria-hidden="true"></i>
            <i class="fa fa-caret-right" aria-hidden="true"></i>
            <i class="fa fa-caret-left" aria-hidden="true"></i>
            <i class="fa fa-caret-right" aria-hidden="true"></i>
          </div>
          <!-- <span class="border border-bottom-dark border-bottom-0" style="min-width: 100px, height: 2px"></span> -->
          <div>
            <i class="fa fa-minus" aria-hidden="true"></i>
            <i class="fa fa-minus" aria-hidden="true"></i>
            <i class="fa fa-minus" aria-hidden="true"></i>
            <i class="fa fa-minus" aria-hidden="true"></i>
            <i class="fa fa-minus" aria-hidden="true"></i>
          </div>
        </div>
        <div class="mb-2">Enter Pincode</div>
        <div class="d-flex justify-content-center flex-column">
          <input
            type="text"
            class="form-control mb-4"
            placeholder="Enter Your Pincode"
          />
          <button class="custom-button mt-2 mb-3" @click="alert('hello')">
            <span>Continue</span>&nbsp;
            <i class="fa fa-angle-right "></i>
          </button>
        </div>
      </b-modal>
    </div>
    <div class="container-fluid" style="padding:0">
      <router-link class="navbar-brand" to="/">
        <img
          src="../assets/slider/logo.png"
          style="height:60px; margin-left:50px"
          alt=""
        />
      </router-link>
      <!-- Margin -->
      <span
        class="nav-item"
        style="margin-left:3%; margin-right:3.5%"
        @click="toggleModal"
      >
        <span class="nav-link" role="button" style="color: #000">
          <span class="locicon"
            ><i class="fa fa-map-marker" style="color:#F69325;"></i
          ></span>
          <span style="margin-left:3px; font-size:11px; ">Deliver to </span
          ><br />
          <span
            style="margin-left:12px; font-weight:bold; position:relative; bottom:7px"
            >{{ selectedLocation }}</span
          >
        </span>
      </span>
      <div class="multi" style="max-width: 350px">
        <multi-select
          :options="products"
          :selected-options="newitem"
          v-model="keyword"
          placeholder="Seach products"
          @select="onSelect"
          style="border-radius:20px; border: 1px #D9D9D9 solid; box-shadow: 2px 2px 5px #D9D9D9;"
        >
        </multi-select>
      </div>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div
        class="collapse navbar-collapse"
        id="navbarSupportedContent"
        style="padding-bottom:10px"
      >
        <ul class="navbar-nav row" style="width:100%; margin:0">
          <li
            class="nav-item mt-2 col-4"
            v-if="!user"
            style="padding:0; text-align:center"
          >
            <router-link class="nav-link" to="/login" style="color: #000; ">
              Sign In
            </router-link>
          </li>
          <b-nav-item-dropdown
            v-if="user"
            class="mt-2"
            style="color: #000; padding-left:25px"
          >
            <template slot="button-content">
              <span style="color: #000">
                {{
                  user.displayName &&
                    (user.displayName.split(" ")[0] || user.displayName)
                }}
              </span>
            </template>
            <b-dropdown-item to="/user/profile">
              Profile
            </b-dropdown-item>
            <b-dropdown-item
              id="hyperLogout"
              @click="
                () => {
                  this.$root.logout();
                }
              "
              >Logout</b-dropdown-item
            >
          </b-nav-item-dropdown>
          <li
            class="nav-item mt-2 col-4"
            style="padding: 0; text-align:center;"
          >
            <router-link
              class="nav-link"
              to="/user/orders"
              v-if="user"
              style="color: #000;"
            >
              My Orders
            </router-link>
            <router-link
              class="nav-link"
              to="/login"
              v-else
              style="color: #000"
            >
              My Orders
            </router-link>
          </li>
          <li
            class="nav-item mt-2 tex-center col-4"
            style="padding: 0; text-align:center"
          >
            <b-button
              class="btn btn-light custom-cart-btn"
              :disabled="carts.length == 0"
              :to="'/CheckOut'"
              style="font-size:0.8em; color:white"
            >
              <span v-if="user">
                <i class="fa fa-shopping-cart" style="font-size:15px"></i>
                <span
                  class="ml-2"
                  style="border:3px solid white; background-color:white; border-radius:70px; color:black; font-weight:bold; font-size:15px"
                  >0{{ carts.length }}</span
                >
                items |
                <strong style="font-size:0.8em; font-size:15px"
                  ><span style="color:black">₹ </span
                  >{{ getCartTotalPrice() }}.00</strong
                >
              </span>
              <span v-else>
                <i class="fa fa-shopping-cart"></i>
                0 items |
                <strong style="font-size:0.8em; font-size:15px"
                  ><span style="color:black">₹ </span>0</strong
                >
              </span>
            </b-button>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <!-- </header> -->
</template>

<script>
import { mapGetters } from "vuex";
import router from "@/modules/router";
import { db, dbFs } from "@/modules/database";
import { MultiSelect } from "vue-search-select";
import axios from "axios";
// import constants from "../modules/constants";
export default {
  data: () => {
    return {
      products: [],
      options: [{ value: "", text: "" }],
      item: "",
      visibleModal: null,
      cartvisibleModal: null,
      carts: [],
      newitem: [],
      keyword: "",
      modal: true,
      cities: [
        {
          name: "New Delhi",
          icon: "fa-building"
        },
        {
          name: "Noida",
          icon: "fa-building"
        },
        {
          name: "Greater Noida",
          icon: "fa-building"
        },
        {
          name: "Ghaziabad",
          icon: "fa-building"
        }
      ],
      location: {
        latitude: "",
        longitude: ""
      },
      loading: false,
      selectedLocation: "",
      errorMsg: null
    };
  },
  mounted() {
    this.setupFirebaseReading();
    this.showModal();
    this.getCurrentLocation();
  },
  computed: {
    ...mapGetters({
      user: "getUser"
    })
  },
  methods: {
    chnageLocation(city) {
      this.selectedLocation = city;
      this.$refs["my-modal"].hide();
    },
    toggleModal() {
      this.$refs["my-modal"].show();
    },
    setupFirebaseReading() {
      let uId = "";
      if (this.user) {
        uId = this.user.uid;
      }
      this.loading = true;
      this.$rtdbBind("carts", db.ref("carts/" + uId))
        .then(() => {
          this.loading = false;
          this.getAllProducts();
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
          this.loadingError = true;
        });
    },
    getAllProducts() {
      let count = 0;
      dbFs
        .collection("products")
        .where("status", "==", true)
        .get()
        .then(res => {
          res.forEach(doc => {
            let data = doc.data();
            this.products.push({
              value: ++count,
              id: doc.id,
              text: data.name
            });
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    getCartTotalPrice() {
      let total = 0;
      this.carts.forEach(cart => {
        total += cart.price;
      });
      return total;
    },
    onSelect(item) {
      this.newitem = item;
      this.keyword = item[0].id;
      router.push("/search/" + this.keyword);
      this.newitem = [];
    },
    showModal() {
      const loc = localStorage.getItem("@aamcartLocation");

      if (loc === null && this.$router.currentRoute.path === "/") {
        setTimeout(() => {
          this.$refs["my-modal"].show();
        }, 500);
      } else {
        this.checkLocation(loc);
      }
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    getCurrentLocation() {
      this.loading = true;
      navigator.geolocation.getCurrentPosition(this.success, this.err, {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      });
    },
    success(position) {
      this.location.latitude = position.coords.latitude;
      this.location.longitude = position.coords.longitude;

      const LatLang = JSON.stringify(this.location);

      localStorage.setItem("@aamcartLocation", LatLang);

      this.getReverseGeoCode();

      this.loading = false;
      this.errorMsg = null;
    },
    err(err) {
      this.loading = false;
      this.errorMsg = err.message;
    },
    getReverseGeoCode() {
      const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${
        this.location.latitude
      },${
        this.location.longitude
      }&sensor=true&key=AIzaSyABMQJLZkns8-CdR0zwdYw6Fm8a7FRBjpI`;

      axios
        .get(url)
        .then(res => {
          this.selectedLocation =
            res.data.results[0].address_components[2].short_name;
        })
        .catch(err => {
          console.log(err);
        });
      this.$refs["my-modal"].hide();
    },
    checkLocation(loc) {
      if (loc !== null) {
        this.location = JSON.parse(loc);
      }
    }
  },
  components: {
    MultiSelect
  }
};
</script>

<style>
.locicon {
  position: relative;
  top: 8px;
  right: 5px;
  font-size: 16px;
}
.nav-bg-color {
  background-color: rgb(255, 255, 255);
  box-sizing: border-box;
  box-shadow: 0.5px 0.5px 5px #000000a5;
}
.selectsearch {
  width: 350px;
  margin-right: 5px;
}
.new-navbar {
  margin-left: 99px;
  padding-top: 46px;
}
.navbar-brand {
  font: Bold 28px/36px Montserrat;
  letter-spacing: -0.28px;
  color: #ffffff;
}
.custom-search {
  width: 300px !important;
  /* border-radius: 33px  */
  border-top-left-radius: 10px !important;
  border-bottom-left-radius: 10px !important;
}
.custom-cart-btn {
  background: #f69325 0% 0% no-repeat padding-box !important;
  border-radius: 24px !important;
}
.location-text {
  color: #ffffff;
}
#masthead {
  background-color: #51381b;
  /* height: 90px; */
}
.dropdown-toggle::after {
  color: #fff !important;
}
.navbar-collapse.in {
  overflow-y: visible !important;
}
.nav_bar_add {
  margin-left: 100px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.menu-new {
  margin-left: 200px;
}
.multi {
  width: 40%;
}
@media (max-width: 767px) {
  .multi {
    width: 40%;
  }
  .menu-new {
    margin-left: 10px !important;
  }
  .container {
    max-width: 920px !important;
  }
}
@media (max-width: 990px) {
  .menu-new {
    margin-left: 10px !important;
  }
  .container {
    max-width: 920px !important;
  }
}
@media only screen and (max-width: 884px) {
  .menu-new {
    margin-left: 10px !important;
  }
}
@media (max-width: 1200px) {
  .menu-new {
    margin-left: 50px !important;
  }
}
@media (max-width: 767px) {
  .menu-new {
    margin-left: 300px !important;
  }
}
@media (max-width: 1200px) {
  .nav_bar_add {
    margin-left: 0px !important;
  }
}
.card-custom {
  background-color: #00000029;
}
.main-color {
  color: #f69325;
}
.form-custom {
  border: none;
  outline: none;
  border-bottom: 3px solid #dedede;
  padding: 5px 10px;
  width: 100%;
}
.custom-button {
  background: linear-gradient(270deg, #ff470bd0 0%, #f69325 100%);
  border: none;
  outline: none;
  padding: 8px 0;
  width: 100%;
  border-radius: 25px;
  color: white;
}
</style>
